// Re-export from canonical location — src/components/Profiles/shared/widgets/registry/
// Import directly from WidgetConfigProvider.tsx (not the barrel) to avoid circular dependency.
export { WidgetConfigProvider, useWidgetConfig } from 'src/components/Profiles/shared/widgets/registry/WidgetConfigProvider';
